import { useCallback, useState } from 'react';

import { useOpenMailAttachmentMutation } from 'core/graphql';

import { IRichMailError } from '../RichMail/richMailModel';

/**
 * ТЗ 0122 — вложение письма почтового клиента: подписанная ссылка на 300 с
 * (`mailAttachmentLink`). Как `useEmailAttachmentLink`: вкладка открывается
 * СРАЗУ по клику, адрес ставится после ответа — окно после `await` браузер
 * заблокировал бы как всплывающее.
 */
export const useMailAttachmentLink = () => {
  const [linkMut] = useOpenMailAttachmentMutation();
  const [busyKey, setBusyKey] = useState<string | null>(null);

  const open = useCallback(
    async (
      messageId: string,
      index: number,
    ): Promise<IRichMailError | null> => {
      const key = `${messageId}:${index}`;
      const tab = window.open('', '_blank');
      if (tab) tab.opener = null;
      setBusyKey(key);
      try {
        const { data } = await linkMut({ variables: { messageId, index } });
        const result = data?.mailAttachmentLink;
        if (!result?.ok || !result.url) {
          tab?.close();
          return {
            code: result?.errorCode || 'NOT_FOUND',
            message: result?.error || '',
          };
        }
        if (tab) tab.location.href = result.url;
        else window.location.assign(result.url);
        return null;
      } catch (caught) {
        tab?.close();
        return {
          code: 'UNAVAILABLE',
          message: caught instanceof Error ? caught.message : '',
        };
      } finally {
        setBusyKey(null);
      }
    },
    [linkMut],
  );

  return { open, busyKey };
};
